
import { Vue } from "vue-class-component";

export default class Lock extends Vue {}
